@if (loader.isLoading | async) {
    <div class="spinner-overlay" data-cy="loader-overlay">
        <div class="spinner" data-cy="loader-spinner">
            <p-progressSpinner strokeWidth="4" fill="transparent" data-cy="loader-image"></p-progressSpinner>
        </div>
    </div>
}
